<template lang="html">
    <div>
   
              <!--   <card-user :user="user"></card-user> -->
    <div class="card">
                <div class="card-image">
                    <figure class="image">
                        <img src="/img/user.png" alt="Image">
                    </figure>
                </div>
                <div class="card-content">
                    <div class="media">
                        <div class="media-left">
                            <figure class="image is-48x48">
                                <img src="/img/user.png" alt="Image">
                            </figure>
                        </div>
                        <div class="media-content">
                            <p class="title is-4">{{item.profile.name+' '+item.profile.last_name}}</p>
                            <p class="subtitle is-6">{{item.email}}</p>
                            <div class="content"> <p>
                                {{item.profile.gender | gender}}
                            </p></div>
                        </div>
                    </div>
                   
                </div>
            </div>
          
    </div>
</template>

<script>
    export default {
        name: "Show",
        props: {
            modalActive: {
                default: false
            },
            item: {}
        }
    }
</script>

<style lang="css">
</style>
